export default {
  GT: 'GT',
  GTE: 'GTE',
  LT: 'LT',
  LTE: 'LTE',
  BETWEEN: 'BETWEEN',
};
